"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUpperBoundMedian = void 0;
const getUpperBoundMedian = (numbers) => {
    if (!numbers.length) {
        return 0;
    }
    const index = Math.floor(numbers.length / 2);
    const sorted = numbers.sort();
    return sorted[index];
};
exports.getUpperBoundMedian = getUpperBoundMedian;
